import { render, staticRenderFns } from "./AttachmentsField.vue?vue&type=template&id=1f261a7b&scoped=true&"
import script from "./AttachmentsField.vue?vue&type=script&lang=js&"
export * from "./AttachmentsField.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsField.vue?vue&type=style&index=0&id=1f261a7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f261a7b",
  null
  
)

export default component.exports